module.exports = __webpack_public_path__ + "img/Janet.2965c5fe.jpg";